webpackJsonp([14620278655657],{

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose([''], ['']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n'], ['\n  display: flex;\n  flex-direction: row;\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 4rem 0;\n'], ['\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  margin: 4rem 0;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  h2 {\n    font-size: 2rem;\n  }\n\n  width: 200px;\n  margin: 0 2rem 2rem 0;\n  padding: 1rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  border-color: ', ';\n'], ['\n  h2 {\n    font-size: 2rem;\n  }\n\n  width: 200px;\n  margin: 0 2rem 2rem 0;\n  padding: 1rem;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-right: 2px solid rgba(0, 0, 0, 0.4);\n  border-bottom: 2px solid rgba(0, 0, 0, 0.4);\n  border-color: ', ';\n']),
	    _templateObject5 = _taggedTemplateLiteralLoose(['\n  background: ', ';\n  height: 10px;\n  width: 100%;\n'], ['\n  background: ', ';\n  height: 10px;\n  width: 100%;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _lodash = __webpack_require__(10);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _styleUtils = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	// Utils
	
	
	var PageWrapper = _styledComponents2.default.section(_templateObject);
	var ListsWrapper = _styledComponents2.default.div(_templateObject2);
	var PagesList = _styledComponents2.default.ul(_templateObject3);
	
	var PageItem = _styledComponents2.default.li(_templateObject4, function (props) {
	  return props.themeColors[0];
	});
	
	var ThemeBar = _styledComponents2.default.div(_templateObject5, function (props) {
	  return (0, _styleUtils.backgroundTheme)(props.themeColors);
	});
	
	var PagesPage = function PagesPage(_ref) {
	  var data = _ref.data;
	
	
	  var grouped = _lodash2.default.groupBy(data.allSitePage.edges, function (e) {
	    return e.node.context && e.node.context.type ? e.node.context.type : 'page';
	  });
	
	  return _react2.default.createElement(
	    PageWrapper,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'The Pages'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here are all of the html pages baked out by Gatsby...'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'i',
	        null,
	        'I\'ve given them a type by providing a context in the createPage call at build time, in gatsby-node.js.'
	      )
	    ),
	    _react2.default.createElement(
	      ListsWrapper,
	      null,
	      _react2.default.createElement(
	        PagesList,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Foods (',
	          grouped.food.length,
	          ')'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Created from Sheets data'
	        ),
	        grouped.food.map(function (_ref2) {
	          var node = _ref2.node;
	          return _react2.default.createElement(
	            PageItem,
	            { key: node.id, themeColors: node.context.content.themecolor.split('-') },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.path },
	              _react2.default.createElement(
	                'h2',
	                null,
	                node.path
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        PagesList,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Nutrients (',
	          grouped.nutrient.length,
	          ')'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Created from Markdown files'
	        ),
	        grouped.nutrient.map(function (_ref3) {
	          var node = _ref3.node;
	          return _react2.default.createElement(
	            PageItem,
	            { key: node.id, themeColors: ['black'] },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.path },
	              _react2.default.createElement(
	                'h2',
	                null,
	                node.path
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        PagesList,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Diets (',
	          grouped.diet.length,
	          ')'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Created from Markdown files'
	        ),
	        grouped.diet.map(function (_ref4) {
	          var node = _ref4.node;
	          return _react2.default.createElement(
	            PageItem,
	            { key: node.id, themeColors: ['black'] },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.path },
	              _react2.default.createElement(
	                'h2',
	                null,
	                node.path
	              )
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        PagesList,
	        null,
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Other (',
	          grouped.page.length,
	          ')'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Created from Page Components'
	        ),
	        _lodash2.default.orderBy(grouped.page, function (_ref5) {
	          var node = _ref5.node;
	          return node.path.length;
	        }).map(function (_ref6) {
	          var node = _ref6.node;
	          return _react2.default.createElement(
	            PageItem,
	            { key: node.id, themeColors: ['black'] },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.path },
	              _react2.default.createElement(
	                'h2',
	                null,
	                node.path
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PagesPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-jamstack-pages-js-ea7ac7f2a613290bfc93.js